import { put, select, call } from 'redux-saga/effects'
import importer from 'common/importer'
const CentersActions = importer('Stores/Centers/Actions')
const { tokens } = importer('Stores/Users/Select', null)
const { saveApplicationUserCenterAccess } = importer('APIs/centers', null)

export default function * main ({applicationUser} ) {
  try {
    const _tokens = yield select(tokens);
    const { token_type, id_token } = _tokens;
    const token = `${token_type} ${id_token}`;
    yield put(CentersActions.addUserCenterAccessLoading());
    const request = {
      donationCenter: applicationUser.donationCenter,
      isDefault: applicationUser.isDefault,
      loginId: applicationUser.loginId
    }
    const res = yield saveApplicationUserCenterAccess(request, token)
    yield put(CentersActions.addUserCenterAccessSuccess(res));
  } catch (error) {
    yield put(CentersActions.addUserCenterAccessFailure( error.response.data));
  }
}